// extracted by mini-css-extract-plugin
export default {"filled":"MaterialIcon_filled__PLQ4w"};